import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { TruthSection } from '../components/TruthSection';
import { WorldChangedSection } from '../components/WorldChangedSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { WhoItsForSection } from '../components/WhoItsForSection';
import { ObjectivesSection } from '../components/ObjectivesSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { PricingSection } from '../components/PricingSection';
import { CTASection } from '../components/CTASection';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-warm-50" data-id="element-267">
      <Hero data-id="element-268" />
      <ProblemSection data-id="element-269" />
      <TruthSection data-id="element-270" />
      <WorldChangedSection data-id="element-271" />
      <SolutionSection data-id="element-272" />
      <FeaturesSection data-id="element-273" />
      <WhoItsForSection data-id="element-274" />
      <ObjectivesSection data-id="element-275" />
      <ObjectionsSection data-id="element-276" />
      <PricingSection data-id="element-277" />
      <CTASection data-id="element-278" />

      <footer className="bg-warm-900 text-warm-400 py-8 text-center text-sm" data-id="element-279">
        <div className="container mx-auto px-4" data-id="element-280">
          <p data-id="element-281">
            © 2024 Chamba Digital para Mexicanas. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs opacity-60" data-id="element-282">
            Este sitio no es parte de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>
    </main>;
}